import {
  DefaultsDocument,
  UserProfileDeleteCcDocument,
  UserProfileDeleteCcMutationVariables,
  UserProfileDocument,
  ValpayConfigDocument,
} from "@graphql/api";

export default async function userProfileDeleteCc(
  ccId?: number,
  ccRefId?: string,
  ccToken?: string,
  ccLast4?: string,
): Promise<boolean> {
  const client = global.window.apolloClient;

  const mutVars: UserProfileDeleteCcMutationVariables = { ccId, ccRefId, ccToken, ccLast4 };
  const result = await client.mutate({
    mutation: UserProfileDeleteCcDocument,
    variables: mutVars,
    // Refetch only the queries that display credit card data
    refetchQueries: [
      { query: UserProfileDocument },
      { query: DefaultsDocument },
      { query: ValpayConfigDocument },
    ],
    awaitRefetchQueries: true,
  });

  return result.data?.userProfileDeleteCc.success || false;
}
